import { createContext, useState } from 'react';
import api from 'services/api';

export const ProdutosContext = createContext();

export const ProdutosProvider = ({ children }) => {
  const [produto, setProduto] = useState(null);
  const [produtoIndicadores, setProdutoIndicadores] = useState(null);
  const [getLoading, setGetLoading] = useState(false);
  const [putLoading, setPutLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [produtos, setProdutos] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getProdutos = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: produtos?.filter,
        page: produtos?.page,
        size: produtos?.size,
        order: produtos?.order,
        ...payload,
      });
      setProdutos((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getProduto = async (id) => {
    try {
      setGetLoading(true);
      setProduto(null);
      const { data } = await api.get(`/Cadastros/Produto/${id}`, {
        params: {
          Kit: true,
          Midias: true,
          Similar: true,
          Variacao: true,
          Registros: true,
          Descricao: true,
          Estrutura: true,
          Processos: true,
          Relacionados: true,
          Substitutos: true,
        },
      });
      setProduto(data);
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postProduto = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Produto', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const putProdutoStatus = async ({ id, cb }) => {
    try {
      setPutLoading(true);
      await api.put(`/Cadastros/Produto/Status/${id}`);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPutLoading(false);
    }
  };

  const putProdutoCusto = async ({ data, cb }) => {
    try {
      setPutLoading(true);
      await api.put(`/Cadastros/Produto/Custo`, data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPutLoading(false);
    }
  };

  const postCopiaEstrutura = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Produto/Copia/Estrutura', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postCopiaProcesso = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Produto/Copia/Processo', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postMidia = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Produto/Midia', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const deleteMidia = async ({ id, cb }) => {
    try {
      setDeleteLoading(true);
      await api.delete(`/Cadastros/Produto/Midia/${id}`);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  const postEtiquetas = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      const { data: dt } = await api.post('/WMS/Armazenagem/Etiqueta', data, {
        responseType: 'blob',
      });
      const file = new Blob([dt], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getProdutoIndicadores = async (id) => {
    try {
      setGetLoading(true);
      setProdutoIndicadores(null);
      const { data } = await api.get(
        `/Graficos/CadastrosProdutoIndicadores/${id}`
      );
      setProdutoIndicadores(data);
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postProdutoCopia = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Produto/Copia', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postProdutoPreco = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Produto/Preco', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getProdutoSaldo = async ({ id, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/Cadastros/Produto/Saldo/${id}`);
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ProdutosContext.Provider
      value={{
        postProduto,
        postLoading,
        getLoading,
        getProdutos,
        produtos,
        putProdutoStatus,
        putLoading,
        getProduto,
        produto,
        postCopiaEstrutura,
        postCopiaProcesso,
        putProdutoCusto,
        deleteMidia,
        postMidia,
        deleteLoading,
        postEtiquetas,
        getProdutoIndicadores,
        produtoIndicadores,
        postProdutoCopia,
        postProdutoPreco,
        getProdutoSaldo,
      }}
    >
      {children}
    </ProdutosContext.Provider>
  );
};
